import { useActions, useState } from '@/utils/map-state';
import { computed, ref, toRefs } from 'vue';
import { uploadAvatarAPI } from '@/api';
import { Toast } from 'vant';
import { promoteUrl } from '@/utils/url';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
export default {
  name: 'AvatarUploadPC',
  components: {
    Cropper
  },
  setup() {
    // public data
    const myAvatar = ref([]);
    const cropperAvatar = ref(null);
    const editMode = ref(false);
    const maxAvatarSize = 1024 * 1024 * 5; // 5MB

    // store
    const store = useStore();

    // route
    const route = useRoute();

    // states
    const {
      userInfo
    } = useState('user', ['userInfo']);

    // actions
    const commonActions = useActions('common', ['showAvatarUploadPopup']);
    const userActions = useActions('user', ['getUserInfo']);

    // computed

    // 顯示用頭像
    const versionControl = computed(() => store.state.versionControl);
    const avatarImgUrl = computed(() => {
      if ((myAvatar === null || myAvatar === void 0 ? void 0 : myAvatar.value.length) > 0 && myAvatar !== null && myAvatar !== void 0 && myAvatar.value[0].content) {
        return myAvatar === null || myAvatar === void 0 ? void 0 : myAvatar.value[0].content;
      } else {
        return promoteUrl() + '/uc_server/avatar.php?uid=' + route.params.userId + '&size=middle&version=' + versionControl.value;
      }
    });

    // private methods
    const uploadImage = () => {
      myAvatar.value[0].content = cropperAvatar.value;
      let params = {
        option: 'avatar',
        pic_file: myAvatar.value[0].content
      };
      try {
        uploadAvatarAPI(params).then(async result => {
          let message = '';
          if (result.head.errCode === 0) {
            cropperAvatar.value = null;
            store.commit('setVersionControl');
            Toast({
              message: '保存成功',
              forbidClick: true,
              onClose: close
            });
          } else {
            editMode.value = false;
            cropperAvatar.value = null;
            Toast({
              message: result.head.errMsg,
              forbidClick: true
            });
          }
        });
      } catch (error) {
        console.log(error);
      }
    };

    // public methods
    const close = () => {
      commonActions.showAvatarUploadPopup({
        'show': false
      });
    };

    //頭像顯示失敗帶入預設頭像
    const avatarImageFail = (event, src) => {
      event.target.src = src;
    };
    const onOversize = () => {
      Toast({
        message: '图片大小不能超过 5Mb',
        forbidClick: true
      });
    };
    const beforeRead = file => {
      if (file.type.indexOf('image') < 0) {
        Toast({
          message: '请上传图片格式',
          forbidClick: true
        });
        return false;
      }
      if (myAvatar.value[0]) {
        if (myAvatar.value[0].name === file.name && myAvatar.value[0].size === file.size) {
          return false;
        } else {
          myAvatar.value = [];
        }
      }
      return true;
    };
    const afterRead = file => {
      myAvatar.value[0]['lastModified'] = file.file.lastModified;
      myAvatar.value[0]['lastModifiedDate'] = file.file.lastModifiedDate;
      myAvatar.value[0]['name'] = file.file.name;
      myAvatar.value[0]['size'] = file.file.size;
      myAvatar.value[0]['type'] = file.file.type;
      editMode.value = true;
    };
    const back = () => {
      cropperAvatar.value = null;
      editMode.value = false;
      myAvatar.value = [];
    };
    const change = data => {
      if (data.canvas) {
        cropperAvatar.value = data.canvas.toDataURL();
      }
    };
    return {
      myAvatar,
      cropperAvatar,
      avatarImgUrl,
      maxAvatarSize,
      editMode,
      close,
      back,
      change,
      avatarImageFail,
      onOversize,
      beforeRead,
      afterRead,
      uploadImage
    };
  }
};